import {
  inject,
  Injectable,
  Renderer2,
  RendererFactory2,
  DOCUMENT,
} from "@angular/core";
import { environment } from "environments/environment";

@Injectable({
  providedIn: "root",
})
export class CookieService {
  readonly #rendererFactory = inject(RendererFactory2);
  readonly #document = inject(DOCUMENT);

  private renderer: Renderer2;

  cookieSrc =
    "https://cdn-cookieyes.com/client_data/1a55c7927379ea4dc8619b3a/script.js";
  cookieId = "cookieyes";

  constructor() {
    this.renderer = this.#rendererFactory.createRenderer(null, null);
  }

  loadCookieScript(): void {
    const cookieScript = this.#document.getElementById(this.cookieId);
    if (environment.COOKIE_BANNER && !cookieScript) {
      const script = this.renderer.createElement("script");
      script.id = this.cookieId;
      script.type = "text/javascript";
      script.src = this.cookieSrc;
      this.renderer.appendChild(this.#document.head, script);
    }
  }
}
